import { Skeleton } from "@/components/ui/skeleton";
import { Card } from "@/components/ui/card";

export function LoadingSkeleton() {
  return (
    <div className="grid grid-cols-12 gap-6">
      {/* Profile Card Skeleton */}
      <div className="hidden lg:block lg:col-span-3">
        <Card className="p-6">
          <div className="flex flex-col items-center">
            <Skeleton className="h-24 w-24 rounded-full" />
            <Skeleton className="h-6 w-32 mt-4" />
            <Skeleton className="h-4 w-24 mt-2" />
          </div>
          <div className="mt-6 space-y-4">
            <div className="flex items-center gap-3">
              <Skeleton className="h-5 w-5" />
              <Skeleton className="h-4 w-full" />
            </div>
            <div className="flex items-center gap-3">
              <Skeleton className="h-5 w-5" />
              <Skeleton className="h-4 w-full" />
            </div>
            <div className="flex items-center gap-3">
              <Skeleton className="h-5 w-5" />
              <Skeleton className="h-4 w-full" />
            </div>
          </div>
        </Card>
      </div>

      {/* Posts Skeleton */}
      <div className="col-span-12 lg:col-span-6 space-y-6">
        <Card className="p-6">
          <div className="flex items-center space-x-4">
            <Skeleton className="h-10 w-10 rounded-full" />
            <Skeleton className="h-10 flex-1" />
          </div>
        </Card>

        {[1, 2, 3].map((i) => (
          <Card key={i} className="p-6">
            <div className="flex items-center space-x-4 mb-4">
              <Skeleton className="h-12 w-12 rounded-full" />
              <div className="flex-1 space-y-2">
                <Skeleton className="h-5 w-32" />
                <Skeleton className="h-4 w-24" />
              </div>
            </div>
            <Skeleton className="h-24 w-full mb-4" />
            <div className="flex justify-between items-center">
              <Skeleton className="h-8 w-20" />
              <div className="flex gap-2">
                <Skeleton className="h-8 w-8" />
                <Skeleton className="h-8 w-8" />
                <Skeleton className="h-8 w-8" />
              </div>
            </div>
          </Card>
        ))}
      </div>

      {/* Ratings Card Skeleton */}
      <div className="hidden lg:block lg:col-span-3">
        <Card className="p-6">
          <Skeleton className="h-8 w-32 mb-4" />
          <div className="space-y-4">
            <div className="flex justify-center mb-6">
              <Skeleton className="h-16 w-16 rounded-full" />
            </div>
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="flex items-center gap-2">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-2 flex-1" />
                <Skeleton className="h-4 w-12" />
              </div>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
}